<div [formGroup]="parentForm" class="checkbox-containerv2">
  <mat-checkbox
    class="checkbox-containerv2"
    (change)="onChecked($event)"
    type="checkbox"
    formControlName="isDisclosureChecked"
    [ngClass]="{ 'highlight-checkbox': getCheckboxError() }"
  >
  </mat-checkbox>
  <p class="be-body-text--sm wrap-checkbox-textv2">
    By checking this box, I consent to receiving a onetime passcode at the
    verification method above and have read and agree with the
    <a
      href="https://www.bestegg.com/terms-of-use/"
      target="_blank"
      rel="noopener noreferrer"
      class="wrap-checkbox-textv2__link"
      >Terms and Conditions</a
    >
    and
    <a
      href="https://www.bestegg.com/privacy-center/privacy-policy/"
      target="_blank"
      rel="noopener noreferrer"
      class="wrap-checkbox-textv2__link"
      >Privacy Policy</a
    >. Message and data rates may apply.
  </p>
</div>
<!-- toggle in error handling when approved by compliance -->
<!-- <small
  *ngIf="
    parentForm.controls['isDisclosureChecked'].hasError('required') &&
    parentForm.controls['isDisclosureChecked'].touched
  "
  class="form-error"
  >Please acknowledge the terms and conditions</small> -->
